import { ApiEndpoints } from "../apiEndpoints";
import { requestApi } from "../apiService";
import {
  UpdateEncryptedDataRequest,
  UpdateEncryptedPasswordRequest,
} from "../types/resetPassword";

export const updateEncryptedPassword = async (
  data: UpdateEncryptedPasswordRequest,
): Promise<boolean> => {
  const response = await requestApi({
    url: ApiEndpoints.ENCRYPTED_PASSWORD + "/update",
    method: "POST",
    data: data,
  });
  const ok: boolean = response.data;
  return ok;
};

export const updateEncryptedData = async (
  data: UpdateEncryptedDataRequest,
): Promise<void> => {
  const response = await requestApi({
    url: ApiEndpoints.UPDATE_ENCRYPTED_DATA,
    method: "POST",
    data: data,
  });
  return response.data;
};
